import { combineReducers } from "redux"
import ui from "./ui"
import drawings from "./drawings"

export default combineReducers({
  ui,
  drawings
})



// WEBPACK FOOTER //
// ./src/reducers/index.js